import {h} from 'preact'
import iconBest from "../../assets/images/icon-best.svg";
import iconLocation from "../../assets/images/icon-location.svg";
import iconSearchMedium from "../../assets/images/icon-search-medium.svg";
import {useContext, useState} from "preact/hooks";
import {HomeContext} from "../../context/HomeContext";
import {servicesMapping} from "../../constants/servicesMapping";
import {useDidUpdate} from "../../utils/hooks/useDidUpdate";

export default () => {
    const context = useContext(HomeContext);


    const getCity = () => {
        let city = context.locations.length === 1 && context.locations[0]?.name === 'Ghana' ? 'Accra' : 'Lagos'
        if (context.country?.name === 'Ghana') {
            city = 'Accra'
        } else {
            city = 'Lagos'
        }
        return city
    }

    let city = getCity()

    useDidUpdate(() => {

    }, [context.country])
    return (
        <ul className="search-categories">
            <li>
                <a onClick={() => {
                    context.openPopup('countries')
                }}>
                    <img src={iconBest} alt="Mirron Top Salons" />
                    <span><strong>Mirron</strong>&nbsp;Top Salons</span>
                </a>
            </li>
            <li>
                <a onClick={() => context.findInCapital(city)}>
                    <img src={iconLocation} alt={"Salons in " + city} />
                    <span>Salons in&nbsp;<strong>{city}</strong></span>
                </a>
            </li>
            <li>
                <a onClick={() => context.openPopup('hair-services')}>
                    <img src={iconSearchMedium} alt="Salons doing Hair services" />
                    <span>Salons doing&nbsp;<strong>Hair services</strong></span>
                </a>
            </li>
            <li>
                <a onClick={() => context.setService(servicesMapping.filter(el => el.categorySlug === 'nail salon')[0])}>
                    <img src={iconSearchMedium} alt="Salons doing Nails" />
                    Salons doing&nbsp;<strong>Nails</strong>
                </a>
            </li>
            <li>
                <a onClick={() => context.setService(servicesMapping.filter(el => el.categorySlug === 'spa')[0])}>
                    <img src={iconSearchMedium} alt="Salons doing Spa" />
                    <span>Salons doing&nbsp;<strong>Spa</strong></span>
                </a>
            </li>
            <li>
                <a onClick={() => context.setService(servicesMapping.filter(el => el.categorySlug === 'make-up')[0])}>
                    <img src={iconSearchMedium} alt="Salons doing Make-up" />
                    <span>Salons doing&nbsp;<strong>Make-up</strong></span>
                </a>
            </li>
            <li>
                <a onClick={() => context.setService(servicesMapping.filter(el => el.categorySlug === 'eyebrows and lashes')[0])} >
                    <img src={iconSearchMedium} alt="Salons doing Eyebrows & Lashes"/>
                    <span>Salons doing&nbsp;<strong>Eyebrows & Lashes</strong></span>
                </a>
            </li>
        </ul>
    )
}